import { ModuleWithProviders, NgModule } from '@angular/core';
import { GOLIATH_ACCOUNTING_ROUTE_PROVIDERS } from './providers/route.provider';

@NgModule()
export class GoliathAccountingConfigModule {
  static forRoot(): ModuleWithProviders<GoliathAccountingConfigModule> {
    return {
      ngModule: GoliathAccountingConfigModule,
      providers: [GOLIATH_ACCOUNTING_ROUTE_PROVIDERS],
    };
  }
}
